import { GroupsApi, UpdateGroupDto } from '../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';
import { getApiConfiguration } from '../../../common';

export const useUpdateGroup = (
  groupId: string,
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, UpdateGroupDto>,
    'mutationFn'
  >,
): UseMutationResult<AxiosResponse<void>, ErrorResponse, UpdateGroupDto> => {
  const groupsApi = new GroupsApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;

  return useMutation(
    ({ name, description }) => groupsApi.updateGroup(tenantId, groupId, {
      name,
      description,
    }),
    options,
  );
};
